var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-299.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order",
    transform: "translate(286.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun-pending-5095024",
    transform: "translate(9.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8190476,6 C24.6693095,5.60077381 24.4319107,5.24011905 24.1247619,4.94440476 L21.6524405,1.2360119 C21.1383512,0.465238095 20.273631,0.00160714286 19.3470833,-5.95238095e-05 L5.65244048,-5.95238095e-05 C4.72589286,0.00156809524 3.86113095,0.465202381 3.34708333,1.2360119 L0.874761905,4.93041667 C0.319053571,5.45310714 0.00261904762,6.18136905 -0.000178571429,6.94446429 L-0.000178571429,22.2218452 C-0.000178571429,22.9586905 0.292559524,23.6650595 0.813392857,24.186131 C1.33445833,24.7069643 2.04083333,24.9997024 2.77767857,24.9997024 L22.2217262,24.9997024 C22.9585714,24.9997024 23.6649405,24.7069643 24.1860119,24.186131 C24.7068452,23.6650655 24.9995833,22.9586905 24.9995833,22.2218452 L24.9995833,6.94446429 C24.9974907,6.62126786 24.9363393,6.30107143 24.8189167,6 L24.8190476,6 Z M10.7636905,19.4446429 C10.7636905,19.8166667 10.565125,20.1605357 10.2428571,20.3465476 C9.92058929,20.5327917 9.52345238,20.5327917 9.20119048,20.3465476 C8.87892262,20.1605357 8.68035714,19.8166488 8.68035714,19.4446429 L8.68035714,9.72202381 C8.68035714,9.35 8.87892262,9.00613095 9.20119048,8.82011905 C9.52345833,8.633875 9.92059524,8.633875 10.2428571,8.82011905 C10.565125,9.00613095 10.7636905,9.35001786 10.7636905,9.72202381 L10.7636905,19.4446429 Z M16.3191667,19.4446429 L16.3193992,19.4446429 C16.3193992,19.8166667 16.1208337,20.1605357 15.7985659,20.3465476 C15.476298,20.5327917 15.0791611,20.5327917 14.7568992,20.3465476 C14.4346314,20.1605357 14.2360659,19.8166488 14.2360659,19.4446429 L14.2360659,9.72202381 C14.2360659,9.35 14.4346314,9.00613095 14.7568992,8.82011905 C15.0791671,8.633875 15.476304,8.633875 15.7985659,8.82011905 C16.1208337,9.00613095 16.3193992,9.35001786 16.3193992,9.72202381 L16.3191667,19.4446429 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.166d7deed79201dd3e68a4082d9786af.svg";
export { ForwardRef as ReactComponent };